export default {
  namespaced: true,
  state: {
    api: {},
    current_page: 1,
    per_page: 10,
    total: null,
    items: null,
    last_page: null,
    lead_current_page: 1,
    lead_per_page: 10,
    lead_total: null,
    lead_items: null,
    lead_last_page: null,
    id: null,
  },
  mutations: {
    SET_ITEM(state, data) {
      state[data[0]] = data[1];
    },
  },
  actions: {
    async SET_API({ commit, dispatch }, api) {
      commit('SET_ITEM', ['api', api]);
      dispatch('GET_LIST');
    },
    async GET_LIST({ commit, state }) {
      let response = await axios.get(state.api.order_list, {
        params: {
          customer: state.id,
          is_lead: '0',
          page: state.current_page,
          per_page: state.per_page,
        },
      });
      response = response.data;
      commit('SET_ITEM', ['items', response.data]);
      commit('SET_ITEM', ['total', response.total]);
      commit('SET_ITEM', ['last_page', response.last_page]);
      commit('SET_ITEM', ['current_page', response.current_page]);
      const lead_response = await axios.get(state.api.order_list, {
        params: {
          customer: state.id,
          is_lead: '1',
          page: state.current_page,
          per_page: state.per_page,
        },
      });
      response = lead_response.data;
      commit('SET_ITEM', ['lead_items', response.data]);
      commit('SET_ITEM', ['lead_total', response.total]);
      commit('SET_ITEM', ['lead_last_page', response.last_page]);
      commit('SET_ITEM', ['lead_current_page', response.current_page]);
    },
    SELECT_ENTRIES({ commit, dispatch }, data) {
      commit('SET_ITEM', ['per_page', data]);
      dispatch('GET_LIST');
    },
    CHANGE_PAGE({ commit, dispatch }, page) {
      commit('SET_ITEM', ['current_page', page]);
      dispatch('GET_LIST');
    },
  },
};
